import moment from 'moment';

/**
 * accepts javascript new Date and converts to YYYY/MM/DD
 * @param  {Date}    date
 * @param  {Boolean} isUTC
 * @return {String}  YYYY/MM/DD
 */
export const getFormattedDate = (date, isUTC = false) => {
  if (isUTC) {
    return moment.unix(date).utc().format('YYYY-MM-DD');
  }

  let year = date.getFullYear();
  let month = (1 + date.getMonth()).toString().padStart(2, '0');
  let day = date.getDate().toString().padStart(2, '0');

  return year + '-' + month + '-' + day;
};

/**
 * accepts javascript new Date and converts to MMM DD, YYYY
 * @param  {Date}    date
 * @return {String}  MMM DD, YYYY
 */
export const getFormattedLongDate = (date) => {
  return date.toLocaleDateString('en-US', {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
  });
};

/**
 * gets previous day
 * @param  {Date}    date
 * @return {Date}
 */
export const getPreviousDay = (date) => {
  const previousDay = new Date(date.getTime());

  previousDay.setDate(date.getDate() - 1);

  return previousDay;
};

/**
 * Safely parses a plain YYYY-MM-DD string into a Date
 * without timezone shift.
 * @param {string} dateString - in format YYYY-MM-DD
 * @returns {Date}
 */
export const parseLocalDate = (dateString) => {
  if (!dateString || typeof dateString !== 'string') return null;

  const [y, m, d] = dateString.split('-').map(Number);
  return new Date(y, m - 1, d);
};

/**
 * checks if a date (YYYY-MM-DD) has started (is today or in the past)
 * @param  {String} dateString - in format YYYY-MM-DD
 * @return {Boolean}
 */
export const hasStarted = (dateString) => {
  if (!dateString) return false;
  const today = new Date().toISOString().split('T')[0];
  return dateString <= today;
};
